

const Landing = () => {
    return <div>feajo</div>
}

export default Landing;